<div class="p-2">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
      <p class="text-gray-600" i18n>Loading customer details...</p>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <div class="text-red-500 text-6xl mb-4">⚠️</div>
      <h2 class="text-xl font-semibold text-gray-800 mb-2" i18n>Error Loading Customer</h2>
      <p class="text-gray-600 mb-4">{{ error }}</p>
      <button (click)="loadCustomerData()"
        class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200"
        i18n>
        Try Again
      </button>
    </div>
  </div>

  <!-- Customer Content -->
  <div *ngIf="!isLoading && !error && customer">
    <!-- Header Section -->
    <div class="flex flex-wrap justify-between gap-2 items-center mb-6">
      <div>
        <div class="flex flex-col sm:flex-row sm:items-center gap-2">
          <h1 class="text-3xl font-bold">{{ getBusinessName() }}</h1>
          <span class="text-[#475569] text-[10px] bg-[#6B7280] text-normal rounded-full px-2 py-1 mb-2 text-white self-start sm:mt-1">
            {{ customer?.refNo || getBusinessId() }}
          </span>
        </div>
        <p class="text-[#6B7280] text-base mb-4" i18n>Customer Details</p>
        <p-button appGlobalLoadingDisable label="Back to Customers" icon="pi pi-arrow-left" class="whitespace-nowrap w-full sm:w-auto"
        styleClass="p-button-outlined p-button-secondary" 
        i18n-label
        [routerLink]="['/admin/customers']" />
      </div>
      <div *ngIf="!isSAOrA()">
        <button pButton type="button" label="Customer Lookup" (click)="newReservation()" icon="pi pi-plus" class="whitespace-nowrap" i18n-label></button>
      </div>
    </div>

    <!-- Tab Section with full width equal buttons -->
    <div class="card mb-6 w-full">
      <p-selectbutton [options]="stateOptions" [(ngModel)]="value" optionLabel="label" optionValue="value"
        (onChange)="onTabChange()" aria-labelledby="basic" styleClass="w-full" />
    </div>

    <!-- Content based on selected tab -->
    <div class="tab-content">
      <!-- Reservations -->
      <div *ngIf="value === 'reservations'">
        <!-- Loading State for Reservations -->
        <div *ngIf="isLoadingReservations && reservations.length === 0" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p class="text-gray-600" i18n>Loading reservations...</p>
          </div>
        </div>
        
        <!-- Reservations Table -->
        <div *ngIf="!isLoadingReservations || reservations.length > 0">

          
          <p-card class="!p-3">
            <div class="overflow-x-auto min-h-screen">
                            <p-table [value]="reservations" [loading]="isLoadingReservations" [paginator]="false"
                [tableStyle]="{'min-width': '1000px', 'width': '100%'}" styleClass="p-datatable-sm p-datatable-striped">
        
                <!-- Header -->
                <ng-template pTemplate="header">
                                  <tr>
                  <th class="min-w-[120px]" i18n>REF NO</th>
                  <th class="min-w-[200px]" i18n>FSR INFORMATION</th>
                  <th class="min-w-[100px] text-center" i18n>PRODUCTS</th>
                  <th class="min-w-[100px] text-center" i18n>NO. OF INTERACTIONS</th>
                  <th class="min-w-[140px] text-center" i18n>VALID TILL</th>
                  <th class="min-w-[100px]" i18n>STATUS</th>
                  <th class="min-w-[120px] cursor-pointer select-none hover:bg-gray-50" 
                  (click)="onSort({field: 'createdAt', order: sortField === 'createdAt' ? sortOrder * -1 : -1})">
                <div class="flex items-center gap-2">
                  <span i18n>CREATED</span>
                  <i [class]="getSortIcon('createdAt')" class="text-sm"></i>
                </div>
              </th>
                  <th class="min-w-[180px]" i18n>ACTIONS</th>
                </tr>
                </ng-template>
        
                <!-- Body -->
                <ng-template pTemplate="body" let-reservation>
                  <tr>
                    <!-- Ref No -->
                    <td class="min-w-[120px]">
                      <div class="text-sm font-medium text-gray-900">
                        {{ reservation.refNo || 'N/A' }}
                      </div>
                    </td>
                    
                    <!-- FSR Information -->
                    <td class="min-w-[300px]">
                      <div class="flex items-center gap-3">
                        <p-avatar [label]="getInitials(reservation.userId?.firstName, reservation.userId?.lastName)" 
                          size="normal" [style]="{'background-color': '#0061DD', 'color': '#FFFFFF'}" shape="circle">
                        </p-avatar>
                        <div>
                          <div class="font-semibold">{{ reservation.userId?.firstName }} {{ reservation.userId?.lastName }}</div>
                          <div class="text-sm text-gray-500">
                            <a href="mailto:{{ reservation.userId?.email }}"
                                class="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
                                [title]="reservation.userId?.email">
                              {{ truncateEmail(reservation.userId?.email) }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </td>
          
                                    <!-- Products Count -->
                <td class="min-w-[100px] text-start">
                  <div class="text-start pl-5" 
                       pTooltip="{{ getProductNames(reservation.products) }}" 
                       tooltipPosition="top">
                    <div class="text-lg font-bold text-blue-600">{{ reservation.products?.length || 0 }}</div>
                    
                  </div>
                </td>

                <!-- Number of Interactions -->
                <td class="min-w-[100px] text-center">
                  <div class="text-center">
                    <div class="text-sm font-normal" >
                      {{ reservation.interactionCount || 0 }}
                    </div>
                  </div>
                </td>
          
                                      <!-- Valid Till -->
                  <td class="min-w-[140px] text-start">
                    <div class="text-start">
                      <div class="text-sm font-medium">{{ formatDate(reservation.expiryDate) }}</div>
                      <div class="text-xs text-gray-500">{{ formatExpiryDate(reservation.expiryDate) }}</div>
                    </div>
                  </td>
          
                    <!-- Status -->
                    <td class="min-w-[100px]">
                      <p-tag [value]="reservation.status" [severity]="getStatusSeverity(reservation.status)">
                      </p-tag>
                    </td>
          
                    <!-- Created Date -->
                    <td class="min-w-[120px]">
                      <span class="text-gray-600">{{ formatDate(reservation.createdAt) }}</span>
                    </td>
          
                                      <!-- Actions -->
                  <td class="min-w-[180px]">
                    <div class="flex items-center gap-2">
                      <p-button 
                        *ngIf="isScheduleVisitStatus(reservation.status) && !isSAOrA()"
                        label="Schedule" 
                        size="small" 
                        icon="pi pi-plus"
                        (onClick)="logInteraction(reservation)"
                        i18n-label>
                      </p-button>
                     
                      <!-- <p-button 
                      *ngIf="!(isViewHistoryStatus(reservation.status))"
                      label="View Interactions" 
                      size="small" 
                      [outlined]="true"
                      (onClick)="viewReservationDetails(reservation)">
                    </p-button> -->

                      <!-- Show View History for completed/final statuses -->
                      <p-button 
                        label="View Interactions" 
                        class="whitespace-nowrap"
                        size="small" 
                        [outlined]="true"
                        (onClick)="viewReservationDetails(reservation)"
                        i18n-label>
                      </p-button>

                      <!-- Show Create Contract button for converted reservations without contracts -->
                      <p-button 
                        *ngIf="shouldShowCreateContractButton(reservation) && !isSAOrA()"
                        label="Create Contract" 
                        class="whitespace-nowrap"
                        size="small" 
                        icon="pi pi-file-plus"
                        (onClick)="createContract(reservation)"
                        i18n-label>
                      </p-button>
                      
                      <!-- Action Menu - Only show for statuses that can have actions -->
                      <!-- <div class="relative" *ngIf="isScheduleVisitStatus(reservation.status)">
                        <p-button appGlobalLoadingDisable 
                          icon="pi pi-ellipsis-v" 
                          size="small"
                          severity="secondary"
                          [text]="true"
                          (onClick)="showActionMenu($event, reservation)"
                          [pTooltip]="'Actions'"
                          i18n-pTooltip>
                        </p-button>
                      </div> -->
                    </div>
                  </td>
                  </tr>
                </ng-template>
      
              <!-- Empty State -->
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="8" class="text-center py-8">
                    <div class="flex flex-col items-center gap-2">
                      <i class="pi pi-calendar text-4xl text-gray-300"></i>
                      <p class="text-gray-500" i18n>No reservations found</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-card>
        </div>
      </div>

      <!-- Contracts Tab -->
      <div *ngIf="value === 'contracts'">
        <!-- Loading State for Contracts -->
        <div *ngIf="isLoadingContracts && contracts.length === 0" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p class="text-gray-600" i18n>Loading contracts...</p>
          </div>
        </div>
        
        <!-- Contracts Table -->
        <div *ngIf="!isLoadingContracts || contracts.length > 0">
          <p-card class="!p-3">
            <div class="overflow-x-auto min-h-screen">
              <p-table [value]="contracts" [loading]="isLoadingContracts" [paginator]="false"
                [tableStyle]="{'min-width': '1200px', 'width': '100%'}" styleClass="p-datatable-sm">

                <!-- Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th class="min-w-[120px]" i18n>REF NO</th>
                    <th class="min-w-[150px]" i18n>FSR</th>
                    <th class="min-w-[120px]" i18n>VALUE</th>
                    <th class="min-w-[120px]" i18n>END DATE</th>
                    <th class="min-w-[120px]" i18n>STATUS</th>
                    <th class="min-w-[120px] cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                      (click)="toggleSort()">
                      <div class="flex items-center justify-between">
                        <span i18n>CREATED</span>
                        <i class="pi" [ngClass]="sortOrder === -1 ? 'pi-sort-down' : 'pi-sort-up'"></i>
                      </div>
                    </th>
                    <th class="min-w-[180px]" i18n>ACTIONS</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-contract>
                  <tr class="cursor-pointer hover:bg-gray-50 transition-colors duration-200" (click)="viewContract(contract)">
                    <!-- Ref No -->
                    <td class="min-w-[120px]">
                      <div class="flex items-center gap-2">
                        <div>
                          <div class="text-sm font-medium text-gray-900">{{ contract.refNo || (contract._id.slice(-8) + '...') }}</div>
                        </div>
                      </div>
                    </td>


                    <!-- FSR -->
                    <td class="min-w-[150px]">
                      <div class="flex items-center gap-2">
                        <div>
                          <div class="text-sm text-gray-500">{{ contract.fsrId?.firstName || 'N/A' }} {{ contract.fsrId?.lastName || 'N/A' }}</div>
                        </div>
                      </div>
                    </td>

                    <!-- Contract Value -->
                    <td class="min-w-[120px]">
                      <span class="text-sm text-gray-500">{{ formatCurrency(contract.contractValue) }}</span>
                    </td>

                    <!-- End Date / Termination Date -->
                    <td class="min-w-[120px]">
                      <span class="text-sm text-gray-500" *ngIf="contract.status?.toUpperCase() !== 'TERMINATED'">{{ formatDate(contract.endDate) }}</span>
                      <span class="text-sm text-gray-500" *ngIf="contract.status?.toUpperCase() === 'TERMINATED'">
                        <span class="text-red-600 font-medium" i18n>Terminated:</span> {{ formatDate(contract.terminationDate || contract.updatedAt) }}
                      </span>
                    </td>

                    <!-- Status -->
                    <td class="min-w-[120px]">
                      <p-tag [value]="getStatusLabel(contract.status, contract.endDate)" [severity]="getStatusBadgeSeverity(contract.status, contract.endDate)">
                      </p-tag>
                    </td>

                    <!-- Created Date -->
                    <td class="min-w-[120px]">
                      <span class="text-sm text-gray-500">{{ formatDate(contract.createdAt) }}</span>
                    </td>

                    <!-- Actions -->
                    <td class="min-w-[180px]" (click)="$event.stopPropagation()">
                      <div class="flex items-center gap-2">
                        <!-- Conditional Actions based on Status -->
                        <div *ngIf="contract.status?.toUpperCase() === 'DRAFT' && !isFSR()">
                          <p-button appGlobalLoadingDisable label="Review Contract" size="small" [outlined]="true" (onClick)="reviewContract(contract)" i18n-label>
                          </p-button>
                        </div>
                        
                        <!-- Show restricted message for FSR users with draft contracts -->
                        <div *ngIf="contract.status?.toUpperCase() === 'DRAFT' && isFSR()" class="text-sm text-gray-500 italic" i18n>
                          Currently Under Review 
                        </div>

                        <!-- Update Contract button for non-DRAFT and non-TERMINATED contracts -->
                        <div *ngIf="contract.status?.toUpperCase() !== 'DRAFT' && contract.status?.toUpperCase() !== 'TERMINATED'" class="flex items-center gap-2">
                          <p-button 
                            appGlobalLoadingDisable 
                            i18n-label
                            label="Update Contract" 
                            icon="pi pi-pencil" 
                            size="small" 
                            [outlined]="true"
                            (onClick)="updateContract(contract)" 
                            [attr.aria-label]="'Update contract ' + contract.refNo">
                          </p-button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>

                <!-- Empty State -->
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="8" class="text-center py-8">
                      <div class="flex flex-col items-center gap-2">
                        <i class="pi pi-file-text text-4xl text-gray-300"></i>
                        <p class="text-gray-500" i18n>No contracts found</p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-card>
        </div>
      </div>

      <div *ngIf="value === 'customer-info'">
        <!-- Customer Information Content -->
        <div class="bg-white rounded-lg border border-gray-200 p-6">
          <!-- Customer Information Section -->
          <div class="mb-8">
            <h3 class="text-lg font-semibold text-gray-900 mb-6" i18n>Customer Information</h3>
            <hr class="border-gray-200 mb-6">

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <!-- Business Name -->
              <div>
                <label class="block text-sm font-normal text-[#475569] mb-1" i18n>Business Name</label>
                <p class="text-black text-base font-medium">{{ getBusinessName() }}</p>
              </div>

              <!-- Business ID -->
              <div>
                <label class="block text-sm font-normal text-[#475569] mb-1" i18n>Business ID</label>
                <p class="text-black font-medium">
                  <span class="md:hidden lg:block">{{ getBusinessId() }}</span>
                  <span class="hidden md:inline lg:hidden">{{ getBusinessId() | slice:0:20 }}{{ (getBusinessId() | slice:20).length > 0 ? '...' : '' }}</span>
                </p>
              </div>

              <!-- No. of employees -->
              <div>
                <label class="block text-sm font-normal text-[#475569] mb-1" i18n>No.of employees</label>
                <p class="text-black font-medium">{{ getNumberOfEmployees() }}</p>
              </div>

              <!-- Zip Code -->
              <div>
                <label class="block text-sm font-normal text-[#475569] mb-1" i18n>Zip Code</label>
                <p class="text-black font-medium">{{ getZipCode() }}</p>
              </div>

              <!-- Industry -->
              <div>
                <label class="block text-sm font-normal text-[#475569] mb-1" i18n>Industry</label>
                <p class="text-black font-medium">{{ getIndustry() }}</p>
              </div>
            </div>
          </div>
          <hr class="border-gray-200 mb-6">

          <!-- Decision Maker Information Section -->
          <div class="mb-8">
            <h3 class="text-lg font-semibold text-gray-900 mb-6" i18n>Decision Maker Information</h3>

            <div class="space-y-6">
              <!-- Dynamic Decision Makers -->
              <div *ngFor="let decisionMaker of decisionMakers; let i = index"
                class="border border-gray-200 rounded-lg p-6 bg-gray-50">
                <h4 class="text-md font-medium text-gray-800 mb-4" i18n>Decision Maker {{ i + 1 }}</h4>

                <div class="grid grid-cols-1 md:grid-cols-12 gap-6 mb-6">
                  <!-- Title -->
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Title</label>
                    <p class="text-gray-900 font-medium">{{ decisionMaker.salutation }}</p>
                  </div>

                  <!-- First Name -->
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-[#475569] mb-1" i18n>First Name</label>
                    <p class="text-gray-900 font-medium">{{ decisionMaker.firstName }}</p>
                  </div>

                  <!-- Last Name -->
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Last Name</label>
                    <p class="text-gray-900 font-medium">{{ decisionMaker.lastName }}</p>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-9 gap-6">
                  <!-- Email -->
                  <div class="col-span-3">
                    <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Email</label>
                    <p class="text-gray-900 font-medium">{{ decisionMaker.email }}</p>
                  </div>

                  <!-- Mobile Number -->
                  <div class="col-span-3">
                    <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Mobile Number</label>
                    <p class="text-gray-900 font-medium">{{ decisionMaker.mobileNumber }}</p>
                  </div>
                </div>
              </div>

              <!-- No Decision Makers Message -->
              <div *ngIf="decisionMakers.length === 0" class="text-center py-8 text-gray-500">
                <p i18n>No decision makers found for this customer.</p>
              </div>

            </div>
          </div>

          <hr class="border-gray-200 mb-6">

          <!-- Other Information Section -->
          <div class="mb-8">
            <h3 class="text-lg font-semibold text-gray-900 mb-6" i18n>Other Information</h3>

            <div class="grid grid-cols-1 md:grid-cols-9 gap-6">
              <!-- Interest Level -->
              <div class="col-span-3">
                <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Interest Level</label>
                <p class="text-gray-900 font-medium">{{ getInterestLevel() }}</p>
              </div>

              <!-- Accepted promotional gifts -->
              <div class="col-span-3">
                <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Accepted promotional gifts</label>
                <p class="text-gray-900 font-medium">{{ getAcceptedPromotionalGifts() }}</p>
              </div>

              <!-- Customer Origin -->
              <div class="col-span-3">
                <label class="block text-sm font-medium text-[#475569] mb-1" i18n>Customer Origin</label>
                <p class="text-gray-900 font-medium">{{ getCustomerOrigin() }}</p>
              </div>
            </div>

            <div class="mt-6">
              <label class="block text-sm font-medium text-[#475569] mb-2" i18n>Notes</label>
              <div *ngIf="customer?.notes; else noNotes" class="border border-gray-200 rounded-lg p-2 sm:p-4 bg-gray-50 text-gray-900 overflow-hidden">
                <div class="notes-content break-words" [innerHTML]="getCustomerNotes()"></div>
              </div>
              <ng-template #noNotes>
                <p class="text-gray-500 italic" i18n>No notes available</p>
              </ng-template>
            </div>
          </div>

          <hr class="border-gray-200 mb-6">

          <!-- Attachments Section -->
          <div class="mb-8">
            <h3 class="text-lg font-semibold text-gray-900 mb-6" i18n>Attachments</h3>
            @if (customerDocuments.length > 0) {
              <div class="space-y-2">
                @for (doc of customerDocuments; track doc; let i = $index) {
                  <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
                    <div class="flex items-center gap-3 flex-1 min-w-0">
                      <i [class]="getFileIcon(doc).icon + ' ' + getFileIcon(doc).color + ' text-xl'"></i>
                      <span class="text-sm text-gray-700 truncate" [title]="getDocumentDisplayName(doc, i)">
                        {{ getDocumentDisplayName(doc, i) }}
                      </span>
                    </div>
                    <div class="flex items-center gap-2 shrink-0">
                      <p-button 
                        appGlobalLoadingDisable 
                        icon="pi pi-external-link" 
                        [text]="true" 
                        [rounded]="true"
                        (onClick)="openDocument(doc)"
                        [pTooltip]="'Open in New Tab'"
                        [attr.aria-label]="'Open ' + getDocumentDisplayName(doc, i) + ' in new tab'"
                        i18n-pTooltip>
                      </p-button>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="text-gray-500 italic" i18n>No attachments uploaded</p>
            }
          </div>

          <!-- Update Button -->
          <div class="pt-4">
            <button (click)="onUpdateClick()"
              class="bg-[#0065AE] cursor-pointer hover:bg-gray-700 text-white font-medium py-2 px-16 rounded-lg transition-colors duration-200"
              i18n>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Menu (outside table for better positioning) -->
  <p-menu #menu [popup]="true" [model]="actionMenuItems" appendTo="body">
  </p-menu>

  <!-- Contract Review Drawer -->
  <!-- Contract Review Drawer -->
  <p-drawer [(visible)]="isDrawerVisible" position="right" [modal]="true" [style]="{width: '90vw', maxWidth: '600px'}"
    (onHide)="closeContractReview()">

    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full">
        <h3 class="text-xl font-bold text-gray-800" i18n>Contract Information</h3>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div *ngIf="selectedContractForReview" class="space-y-6">
        <!-- Contract Header -->
        <div class="mb-6">
          <div class="flex justify-between items-start mb-4">
            <div>
              <h2 class="text-2xl font-bold text-gray-800 mb-2">
                {{ getCustomerName(selectedContractForReview) }}
              </h2>

            </div>
            <div class="text-right w-full">
              <p-tag [value]="getStatusLabel(selectedContractForReview.status, selectedContractForReview.endDate)"
                [severity]="getStatusBadgeSeverity(selectedContractForReview.status, selectedContractForReview.endDate)" styleClass="text-sm">
              </p-tag>
              <p class="text-sm text-gray-500 mt-1 w-full" *ngIf="selectedContractForReview.status?.toUpperCase() !== 'TERMINATED'">
                <span i18n>Valid till:</span> {{ formatDate(selectedContractForReview.endDate) }}
              </p>
              <p class="text-sm text-red-600 mt-1 w-full font-medium" *ngIf="selectedContractForReview.status?.toUpperCase() === 'TERMINATED'">
                <span i18n>Terminated on:</span> {{ formatDate(selectedContractForReview.terminationDate || selectedContractForReview.updatedAt) }}
              </p>
            </div>
          </div>
        </div>

        <!-- Contract Value -->
        <div class="mb-6">
          <div class="flex justify-between items-center border border-[#0061DD] py-3 px-4 rounded-xl bg-[#F3F8FF]">
            <span class="text-sm font-medium text-gray-700" i18n>Contract Value</span>
            <span class="text-lg font-semibold text-gray-900">
              {{ formatCurrency(selectedContractForReview.contractValue) }}
            </span>
          </div>
        </div>

        <!-- Products -->
        <div class="mb-6">
          <div class="flex justify-between items-center mb-3">
            <span class="text-sm font-medium text-gray-700" i18n>Products</span>
          </div>
          
          <!-- Product Values List (when product values are available) -->
          <div *ngIf="hasProductValues(selectedContractForReview)"  class="space-y-2 mb-3">
            <div *ngFor="let product of selectedContractForReview.products" class="flex items-center justify-between p-3 bg-gray-50 border border-gray-200 rounded-lg">
              <div class="flex items-center gap-3 flex-1">
                <p-tag [value]="getProductName(product)" styleClass="text-xs"></p-tag>
                <span class="text-sm text-gray-600" i18n>Value:</span>
              </div>
              <span class="text-sm font-semibold text-gray-900">
                {{ getProductValue(product, selectedContractForReview.productValues) }}
              </span>
            </div>
          </div>
          
          <!-- Products Tags (always shown) -->
          <div *ngIf="!(hasProductValues(selectedContractForReview))"  class="flex flex-wrap gap-2">
            <p-tag *ngFor="let product of selectedContractForReview.products" [value]="getProductName(product)"
              styleClass="text-xs">
            </p-tag>
          </div>
        </div>

        <!-- Contract Description -->
        <div class="mb-6">
          <div class="">

            <!-- Contract Description -->
            <div class="break-words overflow-wrap-anywhere"
              [innerHTML]="sanitizeHtml(selectedContractForReview.description || '')">
              <!-- Fallback content if innerHTML doesn't work -->
              <div *ngIf="!selectedContractForReview.description" class="text-gray-500 italic" i18n>
                No description available
              </div>
            </div>
          </div>
        </div>

        <hr class="h-[1px] text-[#D9D9D9]">

        <!-- Attachments -->
        <div class="mb-6" *ngIf="selectedContractForReview.documents && selectedContractForReview.documents.length > 0">
          <div class="mb-3">
            <span class="text-sm font-medium text-gray-700" i18n>Attachments</span>
          </div>
          <div class="space-y-2">
            <div *ngFor="let doc of selectedContractForReview.documents; let i = index" class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <i [class]="getFileIcon(doc).icon + ' ' + getFileIcon(doc).color"></i>
                <span class="text-sm text-gray-700">{{ getDocumentDisplayName(doc, i) }}</span>
              </div>
              <button class="text-blue-600 hover:text-blue-800 cursor-pointer" (click)="openDocument(doc)">
                <i class="pi pi-external-link"></i>
              </button>
            </div>
          </div>
        </div>

        <hr class="h-[1px] text-[#D9D9D9]">

        <!-- Contract Details Grid -->
        <div class="grid grid-cols-2 gap-6">
          <div class="space-y-4">
            <div>
              <span class="text-xs text-gray-500 block" i18n>Customer</span>
              <span class="text-sm font-medium text-gray-900">
                {{ getCustomerName(selectedContractForReview).split(' ').length > 2 ?
                getCustomerName(selectedContractForReview).split(' ').slice(0, 5).join(' ') + '...' :
                getCustomerName(selectedContractForReview) }}
              </span>
            </div>
            <div>
              <span class="text-xs text-gray-500 block" i18n>FSR</span>
              <span class="text-sm font-medium text-gray-900">
                {{ getFSRName(selectedContractForReview) }}
              </span>
            </div>
            <div>
              <span class="text-xs text-gray-500 block" i18n>Start Date</span>
              <span class="text-sm font-medium text-gray-900">
                {{ formatDate(selectedContractForReview.startDate) }}
              </span>
            </div>
          </div>

          <div class="space-y-4">
            <div>
              <span class="text-xs text-gray-500 block" i18n>Reservation No</span>
              <span class="text-sm font-medium text-gray-900">
                <span class="hidden sm:inline">{{ selectedContractForReview.reservationId || 'N/A' }}</span>
                <span class="sm:hidden">{{ (selectedContractForReview.reservationId || 'N/A').substring(0, 15) }}{{ (selectedContractForReview.reservationId || 'N/A').length > 20 ? '...' : '' }}</span>
              </span>
            </div>
            <div>
              <span class="text-xs text-gray-500 block" i18n>Approved By</span>
              <span class="text-sm font-medium text-gray-900">
                {{ getApproverName(selectedContractForReview) }}
              </span>
            </div>
            <div>
              <span class="text-xs text-gray-500 block" *ngIf="selectedContractForReview.status?.toUpperCase() !== 'TERMINATED'" i18n>End Date</span>
              <span class="text-xs text-gray-500 block text-red-600" *ngIf="selectedContractForReview.status?.toUpperCase() === 'TERMINATED'" i18n>Termination Date</span>
              <span class="text-sm font-medium text-gray-900" *ngIf="selectedContractForReview.status?.toUpperCase() !== 'TERMINATED'">
                {{ formatDate(selectedContractForReview.endDate) }}
              </span>
              <span class="text-sm font-medium text-red-600" *ngIf="selectedContractForReview.status?.toUpperCase() === 'TERMINATED'">
                {{ formatDate(selectedContractForReview.terminationDate || selectedContractForReview.updatedAt) }}
              </span>
            </div>
          </div>

          @if (selectedContractForReview.status === 'DRAFT' && !isFSR()) {
          <div class="flex flex-col md:flex-row gap-3 w-full">
            <p-button appGlobalLoadingDisable label="Approve Contract" icon="pi pi-check" class="whitespace-nowrap"
              (onClick)="approveContract(selectedContractForReview._id)"
              i18n-label>
            </p-button>

            <p-button appGlobalLoadingDisable label="Deny Contract" icon="pi pi-times" class="whitespace-nowrap" [outlined]="true"
              (onClick)="denyContract(selectedContractForReview._id)"
              i18n-label>
            </p-button>
          </div>
          }

          @if ((selectedContractForReview.status === 'ACTIVE' || (selectedContractForReview.status === 'ACTIVE' && isExpiringSoon(selectedContractForReview.endDate))) && !isFSR()) {
          <div class="flex gap-3 w-full">
            <p-button label="Terminate Contract" icon="pi pi-times-circle" class="whitespace-nowrap" severity="danger" [outlined]="true"
              *hasPermission="'contract.terminate'"
              (onClick)="terminateContract(selectedContractForReview._id)"
              i18n-label>
            </p-button>
          </div>
          }

          @if (selectedContractForReview.status === 'TERMINATED' && canCreateNewContract[selectedContractForReview._id] !== false) {
          <div class="flex gap-3 w-full">
            <p-button 
              *ngIf="canCreateNewContract[selectedContractForReview._id] === true"
              i18n-label
              label="Add New Contract for This Customer" 
              icon="pi pi-plus" 
              class="whitespace-nowrap"
              (onClick)="addNewContractForCustomer(selectedContractForReview)">
            </p-button>
            <div *ngIf="checkingContractCreation[selectedContractForReview._id]" class="flex items-center gap-2 text-sm text-gray-500">
              <i class="pi pi-spin pi-spinner"></i>
              <span i18n>Checking available products...</span>
            </div>
            <div *ngIf="canCreateNewContract[selectedContractForReview._id] === false && !checkingContractCreation[selectedContractForReview._id]" class="text-sm text-gray-500 italic">
              <span i18n>All products from this reservation already have active contracts</span>
            </div>
          </div>
          }
        </div>

        <!-- Termination History -->
        @if (selectedContractForReview.terminationHistory && selectedContractForReview.terminationHistory.length > 0) {
        <hr class="h-[1px] text-[#D9D9D9] my-6">
        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-800 mb-4" i18n>Termination History</h4>
          <div class="space-y-4">
            @for (termination of selectedContractForReview.terminationHistory; track termination.terminatedAt) {
            <div class="p-4 bg-red-50 border-l-4 border-red-500 rounded">
              <div class="flex items-start justify-between mb-2">
                <div class="flex items-center gap-2">
                  <i class="pi pi-times-circle text-red-500"></i>
                  <span class="font-semibold text-red-900" i18n>Terminated</span>
                </div>
                <span class="text-sm text-gray-600">{{ formatDateTime(termination.terminatedAt) }}</span>
              </div>
              <div class="mt-2">
                <p class="text-sm font-medium text-gray-700 mb-1" i18n>Reason:</p>
                <p class="text-sm text-gray-800">{{ termination.reason }}</p>
              </div>
              @if (termination.terminatedByName) {
              <div class="mt-2 text-xs text-gray-600">
                <span i18n>Terminated by:</span> {{ termination.terminatedByName }}
              </div>
              }
            </div>
            }
          </div>
        </div>
        }

        <!-- Rejection History and Timeline -->
        @if (selectedContractForReview.rejectionHistory && selectedContractForReview.rejectionHistory.length > 0) {
        <hr class="h-[1px] text-[#D9D9D9] my-6">
        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-800 mb-4" i18n>Rejection History</h4>
          <div class="space-y-4">
            @for (rejection of selectedContractForReview.rejectionHistory; track rejection.rejectedAt) {
            <div class="p-4 bg-red-50 border-l-4 border-red-500 rounded">
              <div class="flex items-start justify-between mb-2">
                <div class="flex items-center gap-2">
                  <i class="pi pi-times-circle text-red-500"></i>
                  <span class="font-semibold text-red-900" i18n>Rejected</span>
                </div>
                <span class="text-sm text-gray-600">{{ formatDateTime(rejection.rejectedAt) }}</span>
              </div>
              <div class="mt-2">
                <p class="text-sm font-medium text-gray-700 mb-1" i18n>Reason:</p>
                <p class="text-sm text-gray-800">{{ rejection.reason }}</p>
              </div>
              @if (rejection.rejectedByName) {
              <div class="mt-2 text-xs text-gray-600">
                <span i18n>Rejected by:</span> {{ rejection.rejectedByName }}
              </div>
              }
            </div>
            }
          </div>
        </div>
        }

        <!-- Submission Timeline -->
        @if (selectedContractForReview.submissionHistory && selectedContractForReview.submissionHistory.length > 0) {
        <hr class="h-[1px] text-[#D9D9D9] my-6">
        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-800 mb-4" i18n>Submission Timeline</h4>
          <div class="space-y-3">
            @for (submission of selectedContractForReview.submissionHistory; track submission.submittedAt) {
            <div class="flex items-start gap-3 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
              <i class="pi pi-send text-blue-500 mt-1"></i>
              <div class="flex-1">
                <div class="flex items-center justify-between">
                  <span class="font-semibold text-blue-900" i18n>Submitted</span>
                  <span class="text-sm text-gray-600">{{ formatDateTime(submission.submittedAt) }}</span>
                </div>
                <p class="text-xs text-gray-600 mt-1" i18n>Status: {{ submission.status }}</p>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>

    </ng-template>
  </p-drawer>

  <!-- Rejection Reason Dialog -->
  <p-dialog 
    [(visible)]="showRejectionDialog" 
    [modal]="true" 
    [style]="{width: '500px'}"
    [closable]="true"
    (onHide)="cancelRejection()"
    header="Reject Contract"
    i18n-header>
    <div class="space-y-4">
      <p class="text-gray-700" i18n>Please provide a reason for rejecting this contract. This reason will be visible to the FSR.</p>
      <div>
        <label for="rejectionReason" class="block text-sm font-medium text-gray-700 mb-2" i18n>Rejection Reason *</label>
        <textarea 
          id="rejectionReason"
          pInputTextarea 
          [(ngModel)]="rejectionReason"
          placeholder="Enter the reason for rejection..."
          i18n-placeholder
          rows="5"
          class="w-full"
          [autoResize]="true">
        </textarea>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex gap-2 justify-end">
        <p-button 
          label="Cancel" 
          icon="pi pi-times" 
          [outlined]="true"
          (onClick)="cancelRejection()"
          i18n-label>
        </p-button>
        <p-button 
          label="Confirm Rejection" 
          icon="pi pi-check" 
          severity="danger"
          (onClick)="confirmRejection()"
          [disabled]="!rejectionReason || rejectionReason.trim() === ''"
          i18n-label>
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Termination Reason Dialog -->
  <p-dialog 
    [(visible)]="showTerminationDialog" 
    [modal]="true" 
    [style]="{width: '500px'}"
    [closable]="true"
    (onHide)="cancelTermination()"
    header="Terminate Contract"
    i18n-header>
    <div class="space-y-4">
      <p class="text-gray-700" i18n>Please provide a reason for terminating this contract. This reason will be visible to the FSR.</p>
      <div>
        <label for="terminationReason" class="block text-sm font-medium text-gray-700 mb-2" i18n>Termination Reason</label>
        <textarea 
          id="terminationReason"
          pInputTextarea 
          [(ngModel)]="terminationReason"
          placeholder="Enter the reason for termination (optional)..."
          i18n-placeholder
          rows="5"
          class="w-full"
          [autoResize]="true">
        </textarea>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex gap-2 justify-end">
        <p-button 
          label="Cancel" 
          icon="pi pi-times" 
          [outlined]="true"
          (onClick)="cancelTermination()"
          i18n-label>
        </p-button>
        <p-button 
          label="Confirm Termination" 
          icon="pi pi-check" 
          severity="danger"
          (onClick)="confirmTermination()"
          i18n-label>
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Confirmation Dialogs -->
  <p-confirmDialog></p-confirmDialog>

  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>